import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Banner.css";

function Banner() {
  const slides = [
    {
      title: "Advanced Care",
      subtitle: "for Every Scar",
      buttonText: "Buy Now",
      imgSrc: "./assets/Hero-Banner-Slider-scaled.webp",
      contentImg: "./assets/Slider.webp",
      titleColor: "#1c2b57",
      title2: "RemeCure Scar",
      description:
        "RemeCure Scar Silicon Sheets are your choice for smoother, less visible scars. Clinically tested and made with medical-grade silicon, they create an optimal healing environment to reduce the appearance of scars from surgeries, burns, acne, and more.",
      description2:
        "Whether your scars are recent or old, RemeCure Scar Silicon Sheets provide a simple, effective, and non-invasive solution that fits seamlessly into your daily routine.",
    },
    {
      title: "Beautiful Ending, New",
      subtitle: "Beginning",
      buttonText: "Buy Now",
      imgSrc: "./assets/Hero-Banner-Slider-4-scaled.webp",
      contentImg: "./assets/Slider-1.webp",
      titleColor: "#581D79",
      title2: "RemeCure Scar",
      description:
        "RemeCure Scar Silicon Sheets are your choice for smoother, less visible scars. Clinically tested and made with medical-grade silicon, they create an optimal healing environment to reduce the appearance of scars from surgeries, burns, acne, and more.",
      description2:
        "Whether your scars are recent or old, RemeCure Scar Silicon Sheets provide a simple, effective, and non-invasive solution that fits seamlessly into your daily routine.",
    },
    {
      title: "Healing Scars,",
      subtitle: "Big and Small",
      buttonText: "Buy Now",
      imgSrc: "./assets/Hero-Banner-Slider-5-scaled.webp",
      contentImg: "./assets/Slider-2.webp",
      titleColor: "#EDA16D",
      title2: "RemeCure Scar",
      description:
        "RemeCure Scar Silicon Sheets are your choice for smoother, less visible scars. Clinically tested and made with medical-grade silicon, they create an optimal healing environment to reduce the appearance of scars from surgeries, burns, acne, and more.",
      description2:
        "Whether your scars are recent or old, RemeCure Scar Silicon Sheets provide a simple, effective, and non-invasive solution that fits seamlessly into your daily routine.",
    },
    {
      title: "Redefine Healing After",
      subtitle: "Abdominoplasty",
      buttonText: "Buy Now",
      imgSrc: "./assets/Hero-Banner-Slider-3-scaled.webp",
      contentImg: "./assets/Slider-3.webp",
      titleColor: "#3e9261",
      title2: "RemerCure Scar",
      description:
        "RemeCure Scar Silicon Sheets are your choice for smoother, less visible scars. Clinically tested and made with medical-grade silicon, they create an optimal healing environment to reduce the appearance of scars from surgeries, burns, acne, and more.",
      description2:
        "Whether your scars are recent or old, RemeCure Scar Silicon Sheets provide a simple, effective, and non-invasive solution that fits seamlessly into your daily routine.",
    },
    {
      title: "Elevate Post-Surgery",
      subtitle: "Care",
      buttonText: "Buy Now",
      imgSrc: "./assets/Hero-Banner-Slider-2-scaled.webp",
      contentImg: "./assets/Slider-4.webp",
      titleColor: "#ae438e",
      title2: "RemeCure Scar",
      description:
        "RemeCure Scar Silicon Sheets are your choice for smoother, less visible scars. Clinically tested and made with medical-grade silicon, they create an optimal healing environment to reduce the appearance of scars from surgeries, burns, acne, and more.",
      description2:
        "Whether your scars are recent or old, RemeCure Scar Silicon Sheets provide a simple, effective, and non-invasive solution that fits seamlessly into your daily routine.",
    },
    {
      title: "Elevate Post-Surgery",
      subtitle: "Care",
      buttonText: "Buy Now",
      imgSrc: "./assets/Hero-Banner-Slider-1-scaled.webp",
      titleColor: "#25a1ba",
      contentImg: "./assets/Slider-5.webp",
      title2: "RemeCure Scar",
      description:
        "RemeCure Scar Silicon Sheets are your choice for smoother, less visible scars. Clinically tested and made with medical-grade silicon, they create an optimal healing environment to reduce the appearance of scars from surgeries, burns, acne, and more.",
      description2:
        "Whether your scars are recent or old, RemeCure Scar Silicon Sheets provide a simple, effective, and non-invasive solution that fits seamlessly into your daily routine.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setActiveIndex(newIndex),
    appendDots: (dots) => (
      <div>
        <ul className="custom-dots">{dots}</ul>
      </div>
    ),
  };

  return (
    <section className="b-wrapper">
      <Slider {...settings} className="slider-container">
        {slides.map((slide, index) => (
          <div key={index} className="slide">
            <div
              className="slide-image"
              style={{ backgroundImage: `url(${slide.imgSrc})` }}
            >
              <div className="content-container">
                <div className="overlay-text">
                  <h1 style={{ color: slide.titleColor }}>{slide.title}</h1>
                  <h1 style={{ color: slide.titleColor }}>{slide.subtitle}</h1>
                  <button className="banner-button">{slide.buttonText}</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Dynamic Content Section */}
      <div
        className="dynamic-content-container fade-zoom"
        key={activeIndex} // ✅ This triggers the animation
      >
        <div
          className="content-section"
          style={{ backgroundColor: slides[activeIndex].titleColor }}
        >
          <img
            src={slides[activeIndex].contentImg}
            alt="content"
            className="content-image"
          />
          <div className="content-text">
            <h2>{slides[activeIndex].title2}</h2>
            <p>
              {slides[activeIndex].description}
              <br />
              {slides[activeIndex].description2}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
